import { Heading2, Radio, RadioGroup, Stack } from "@myphx-engineering/phx-design-system";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/client/components/consent-filter/FilterRadioGroup.tsx
const FilterRadioGroup = ({ title, selection, onChange, options }) => {
	return /* @__PURE__ */ jsxs(Stack, {
		gap: "xxs",
		children: [/* @__PURE__ */ jsx(Heading2, { children: title }), /* @__PURE__ */ jsx(RadioGroup, {
			value: selection,
			onChange: (e) => {
				onChange(e);
			},
			children: /* @__PURE__ */ jsx(Stack, {
				gap: 0,
				children: options.map(({ label, value }) => /* @__PURE__ */ jsx(Radio, {
					value,
					label
				}, value))
			})
		})]
	});
};

//#endregion
export { FilterRadioGroup };